import React, { useEffect, useState } from 'react';
import IntellendLogo from "@/components/IntellendLogo";
import { useIsMobile } from "@/hooks/use-mobile";

const JourneyHeader = () => {
  const isMobile = useIsMobile();
  const [bapLogo, setBapLogo] = useState<string | null>(null);
  const [bapId, setBapId] = useState<string | null>(null);

  useEffect(() => {
    const sessionBapId = sessionStorage.getItem('whitespace_bap_id');
    const sessionBapLogo = sessionStorage.getItem('whitespace_bap_logo');

    if (sessionBapId) {
      setBapId(sessionBapId);
    }
    if (sessionBapLogo) {
      setBapLogo(sessionBapLogo);
    }
  }, []);

  return (
    <header className="bg-intellend-green p-3 md:p-4">
      <div className={`container mx-auto flex ${bapLogo ? 'justify-between' : 'justify-center'} items-center`}>
        {bapLogo && (
          <div className="bg-intellend-white p-1 md:p-2 rounded-md">
            <img
              src={bapLogo}
              alt={`${bapId || 'BAP'} Logo`}
              className="h-8 md:h-12 w-auto object-contain"
              onLoad={() => console.log('[JourneyHeader] BAP logo loaded successfully')}
              onError={(e) => {
                console.warn(`[JourneyHeader] Failed to load BAP logo`);
                (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
              }}
            />
          </div>
        )}
        <div className="bg-intellend-white p-1 md:p-2 rounded-md flex items-center justify-center h-10 md:h-16">
          <IntellendLogo size={isMobile ? "sm" : "md"} />
        </div>
      </div>
    </header>
  );
};

export default JourneyHeader;
